import React from 'react';
import Icon from 'components/AppIcon';

const TitleSlide = () => {
  return (
    <div className="text-center py-16">
      <div className="max-w-4xl mx-auto">
        {/* Logo and Brand */}
        <div className="flex items-center justify-center space-x-4 mb-8">
          <div className="w-20 h-20 bg-primary rounded-2xl flex items-center justify-center shadow-lg">
            <Icon name="Scale" size={40} color="white" />
          </div>
          <div className="text-left">
            <h1 className="text-6xl font-heading font-bold text-primary">LawDesk KE</h1>
            <p className="text-xl text-text-secondary mt-2">Legal Practice Management Platform</p>
          </div>
        </div>

        {/* Tagline */}
        <div className="mb-12">
          <h2 className="text-3xl font-heading font-semibold text-text-primary mb-4">
            Connecting Clients with Qualified Lawyers
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Streamlining legal practice management and making legal services accessible across Kenya
          </p>
        </div>

        {/* Key Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="text-center">
            <div className="w-16 h-16 bg-primary-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Icon name="Search" size={32} className="text-primary" />
            </div>
            <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">Find Lawyers</h3>
            <p className="text-text-secondary">Match clients with qualified legal professionals</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-primary-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Icon name="Briefcase" size={32} className="text-primary" />
            </div>
            <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">Manage Cases</h3>
            <p className="text-text-secondary">Complete practice management solution</p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-primary-100 rounded-xl flex items-center justify-center mx-auto mb-4">
              <Icon name="Shield" size={32} className="text-primary" />
            </div>
            <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">Secure Platform</h3>
            <p className="text-text-secondary">Bank-level security for legal communications</p>
          </div>
        </div>

        {/* Status Badge */}
        <div className="inline-flex items-center space-x-2 bg-success-50 text-success-600 px-6 py-3 rounded-full">
          <div className="w-2 h-2 bg-success-500 rounded-full"></div>
          <span className="font-medium">Platform Ready for Launch</span>
        </div>

        {/* Date */}
        <p className="text-text-secondary mt-8">
          {new Date().toLocaleDateString('en-KE', { 
            year: 'numeric', 
            month: 'long',
            day: 'numeric'
          })}
        </p>
      </div>
    </div>
  );
};

export default TitleSlide;